import { render } from "./ModalPaymentSupplier.vue?vue&type=template&id=5c303969"
import script from "./ModalPaymentSupplier.vue?vue&type=script&lang=js"
export * from "./ModalPaymentSupplier.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__